import Header from "components/Header";
import { routes } from "constants/routes";
import CreateFundingRequest from "features/main/HaulPay/Broker/modules/CreateFundingRequest";
import MainLayout from "layouts/Main";

export default function CreateBrokerFR() {
  return (
    <MainLayout
      desktopTitle="Post Load"
      customHeader={<Header label="Create Funding Request" goBackPath={routes.LOADS_POSTED_ALL} />}
      className="px-5">
      <CreateFundingRequest />
    </MainLayout>
  );
}
